import { gql } from '@apollo/client';

export const GET_USER_CONNECTIONS_COUNT = gql /* GraphQL */ `
	query GetUserGuardians($id: ID!) {
		user(data: { userId: $id }) {
			id
			role
			guardians {
				id
			}
		}
	}
`;
